import { Deserializable } from '../../deserializable';
import { RepresentativeRole } from './representative-role';

/**
 * Model of third step of register form
 */
export class Representative extends Deserializable {
  /**
   * @constructor
   */
  constructor(
    // NOSONAR
    public firstName: string,
    public lastName: string,
    public email: string,
    public picture: string,
    public password: string,
    public language?: string,
    public businessId?: number,
    public id?: number,
    public role?: RepresentativeRole,
    public active?: boolean,
    public registerStatus?: string
  ) {
    super();
  }
}
